module.exports = __webpack_public_path__ + "static/img/lange_crub_3.2196f61e.jpg";